"use client";
import { Review } from "@/app/me/[slug]/Mentor/Mentor.schema";
import PinnedReviewComponent from "./PinnedReview";

const PinnedReview = (props: { review: Review }) => {
  const jumpToReviews = () => {
    const top_offset = document.getElementById("reviews_container")?.offsetTop;
    window.scrollTo({
      top: top_offset,
      behavior: "smooth",
    });
  };

  return (
    <PinnedReviewComponent
      review={props.review}
      jumpToReviews={jumpToReviews}
    />
  );
};

export default PinnedReview;
